import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Board from "./pages/Board";
import AdminDashboard from "./pages/AdminDashboard";
import Navbar from "./components/Navbar";
import { Toaster } from "sonner";

const ProtectedRoute = ({ children, adminOnly }) => {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="w-10 h-10 border-2 border-black border-t-transparent rounded-full animate-spin" />
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/board" replace />;
    return children;
};

function AppRouter() {
    const location = useLocation();
    // CRITICAL: synchronous check for session_id in URL hash BEFORE other routes
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/board"
                element={
                    <ProtectedRoute>
                        <>
                            <Navbar />
                            <Board />
                        </>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute adminOnly>
                        <>
                            <Navbar />
                            <AdminDashboard />
                        </>
                    </ProtectedRoute>
                }
            />
            <Route path="/" element={<Navigate to="/board" replace />} />
            <Route path="*" element={<Navigate to="/board" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
